import { defaultFetch } from './baseApi';

export type InfratelTemplateType = {
	companyId: number;
	createdAt: string;
	description: string;
	id: number;
	inputType: string;
	label: string;
	projectType: string;
	files: {
		id: number;
		code: string;
		label: string;
		createdAt: string;
	}[];
};

export const getInfratelTemplateConfigurations = async () =>
	defaultFetch<InfratelTemplateType[]>(`/v0/templateconfigurations?label_like=Regole Infratel`);

export const getSmartGridTemplateConfiguration = async () =>
	defaultFetch<InfratelTemplateType[]>(`/v0/templateconfigurations?label_like=Regole SmartGrid`);

export type ProjectEntityType = 'contracts' | 'payments' | 'invoice' | 'timesheets';

export const exportPopulatedProjectTemplate = (projectId: string, entityType: ProjectEntityType) =>
	defaultFetch(`/v0/templates/projects/${projectId}/${entityType}/export`);

export const exportPopulatedTemplate = (entityType: 'tenders' | 'frameworkcontracts') => defaultFetch(`/v0/templates/${entityType}/export`);
